'use client';

import { c as _c } from "react/compiler-runtime";
import { useQuery } from '@tanstack/react-query';
import { UnauthQueryOptions } from '@/api';
import { WelloOnlySectionClient } from './WelloOnlySectionClient';
const TEN_SECONDS = 10 * 1000;
export const WelloOnlySection = () => {
  const $ = _c(6);
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = {
      ...UnauthQueryOptions["get:/wello/v2/allows/home/event/december/benefit-amount"](),
      refetchInterval: TEN_SECONDS
    };
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  const {
    data
  } = useQuery(t0);
  let t1;
  if ($[1] !== data?.context) {
    t1 = data?.context || {};
    $[1] = data?.context;
    $[2] = t1;
  } else {
    t1 = $[2];
  }
  const {
    currentTimeEvent1ParticipantLimit: t2,
    currentTimeEvent1RewardCount: t3
  } = t1;
  const participantLimit = t2 === undefined ? 0 : t2;
  const rewardCount = t3 === undefined ? 0 : t3;
  let t4;
  if ($[3] !== participantLimit || $[4] !== rewardCount) {
    t4 = <WelloOnlySectionClient participantLimit={participantLimit} rewardCount={rewardCount} />;
    $[3] = participantLimit;
    $[4] = rewardCount;
    $[5] = t4;
  } else {
    t4 = $[5];
  }
  return t4;
};